import LogoImg from "assets/logo/df-logo.png";
import "./index.scss";

class Logo {
  createLogo() {
    const logo = window.document.createElement("img");
    logo.className = "df-logo";
    logo.src = LogoImg;
    this.container.appendChild(logo);
    return logo;
  }

  onAdd(map) {
    this.map = map;
    this.container = document.createElement("div");
    this.container.className = "mapboxgl-logo";
    this.createLogo();

    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}

export default Logo;
